export enum EquipmentTypeEnum {
  Unknown = 0,
  Food = 1 << 0,
  Technical = Food << 1,
  FoodAndTechnical = Food | Technical,
}
